var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylistOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M17.92 0a6.03 6.03 0 0 1 6.06 6.06v6a6.03 6.03 0 0 1-6.06 6.04H12.5v1.14A2.75 2.75 0 0 1 9.73 22H7.07a.93.93 0 0 1 0-1.86h2.66a.9.9 0 0 0 .63-.27.9.9 0 0 0 .27-.63V18.1H6.05A6.03 6.03 0 0 1 0 12.05v-6A6.03 6.03 0 0 1 6.05 0h11.88zm2.96 3.1a4.18 4.18 0 0 0-2.96-1.24H6.05c-1.15 0-2.2.48-2.96 1.24a4.18 4.18 0 0 0-1.23 2.95v6a4.18 4.18 0 0 0 4.19 4.19h11.87a4.18 4.18 0 0 0 4.19-4.19v-6c0-1.15-.47-2.2-1.23-2.95zM14.02 22a.93.93 0 0 1 0-1.87h2.89a.93.93 0 0 1 0 1.86h-2.89zm1.36-12.4l-5 2.89a.93.93 0 0 1-1.4-.8V5.9a.93.93 0 0 1 1.46-.77l2.44 1.4.04.04 2.45 1.41a.93.93 0 0 1 0 1.6v.01zm-3.43-.16l1.1-.64L12 8.19l-.05-.03-1.1-.63v2.54l1.1-.63z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistOff);
export default __webpack_public_path__ + "static/media/playlist-off.1c837093e14b184d068ce5a5a48b061a.svg";
export { ForwardRef as ReactComponent };